import { systemSettingsService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    settings: {},
    saving: false
  }
}

const actions = {
  getSystemSettings ({ commit }) {
    return systemSettingsService.getSystemSettings().then(systemSettings => {
      return systemSettings.result
    })
  },

  saveSystemSettings ({ commit }, systemSettings) {
    commit('startSave')
    return systemSettingsService.saveSystemSettings(systemSettings)
      .then(systemSettings => {
        commit('endSave')
        commit('saveSuccess', systemSettings.result)
        return systemSettings.result
      }).catch(error => {
        commit('endSave')
        commit('saveFailure')
        return Promise.reject(error)
      })
  }
}

const mutations = {
  startSave (state) {
    state.all.saving = true
  },
  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  saveSuccess (state) {
    Vue.prototype.$toast('Systeminställningar sparade', 'success')
  },

  saveFailure (state, error) {
    Vue.prototype.$toast('Kunde inte spara systeminställningar', 'error')
  }
}

export const systemSettings = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/system-settings.module.js